import config from "../config/ConfigApplication";

export const CD_CHANNEL_TRADEMAP = config.channel || "13";
